<!--
  OwnerFilter is a filter component that allows the user to filter by owner.
  It reads/writes from the `creator` URL query param.
-->
<script>
import { mapState } from 'vuex';
import { iFilter } from '@inscribe/signal';
import { getAndSyncQueryParams, updateQueryParams } from '@/utils/queryParams';

export default {
  components: {
    iFilter,
  },
  data() {
    return {
      params: getAndSyncQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
      }),
    };
  },
  computed: {
    ...mapState(['currentUser', 'tags']),
    ownersOptions() {
      const { email, uuid } = this.currentUser;
      return [
        { label: email, id: uuid },
        ...this.currentUser.organisation.users
          .filter((user) => user.id !== uuid)
          .map((user) => ({
            label: user.email,
            id: user.id,
          })),
      ];
    },
    value() {
      const { creator } = this.params;
      if (!creator) {
        return [];
      }
      const creatorsArray = Array.isArray(creator) ? creator : [creator];
      return creatorsArray.map(
        (id) =>
          this.ownersOptions.find((option) => option.id === id)?.label || id,
      );
    },
  },
  watch: {
    '$route.fullPath': {
      handler: function (newFullPath) {
        this.params = getAndSyncQueryParams({
          fullPath: newFullPath,
          router: this.$router,
          store: this.$store,
        });
      },
    },
  },
  methods: {
    onSelectionChanged(updated) {
      const updatedIds = updated.selection.map((t) => t.id);
      updateQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
        updates: {
          creator: updatedIds.length === 0 ? undefined : updatedIds.join(','),
        },
      });
    },
  },
};
</script>

<template>
  <iFilter
    label="Owner"
    data-testid="customer-owner-filter"
    :options="ownersOptions"
    :value="value"
    :max-selectable="1"
    :searchable="true"
    @selection-changed="onSelectionChanged"
  />
</template>
